import * as Sentry from '@sentry/react';

// When a ticket/order/job created by "Company A" is viewed by a user from "Company B"
// (e.g. the Approve Jobs ticket drawer renders SiteSelection with the job's company id),
// the UI fetches Company A's record by id. That company is outside Company B's
// authorized_or_managed scope, so the API returns a 404. This is expected cross-company
// behavior, not an actionable client error.
export function ignoreCompanyById404Rule(event: Sentry.ErrorEvent) {
  const is404ErrorResponse = event.contexts?.response?.status_code === 404;
  const isGETRequest = event.request?.method === 'GET';

  const requestUrl = event.request?.url ?? '';
  const regexp = /v1\/companies\/(\w|-){36}$/;
  const isFetchingCompany = regexp.test(requestUrl);

  return is404ErrorResponse && isGETRequest && isFetchingCompany;
}
